import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ModelLocatorService } from '../config/model-locator.service';

@Injectable({
    providedIn: 'root'
})

export class GuardService {

    public modelLocator: ModelLocatorService;
    protected router: Router;

    public inatividade: boolean;

    constructor(
        injector: Injector,
        modelLocatorService: ModelLocatorService
    ) {
        this.modelLocator = modelLocatorService;
        this.router = injector.get(Router);
    }

    async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        // DEFINE URL DE RETORNO
        this.modelLocator.urlretorno = state.url;

        // VERIFICA SE ESTA AUTENTICADO.
        if (this.modelLocator.logado != true) {

            return this.router.navigate(['/login']);

        } else {

            return true;

        }

    }

}
